import { languageProficiency } from '@seek/ca-myprofile-utils';
import gql from 'graphql-tag';

export const getLanguages = gql`
  query GetLanguageProficiencies {
    viewer {
      _id
      languageProficiencies {
        ...languageProficiency
      }
    }
  }
  ${languageProficiency}
`;

export const updateLanguageProficiency = gql`
  mutation UpdateLanguageProficiency(
    $updateLanguageProficiencyInput: UpdateLanguageProficiencyInput!
  ) {
    updateLanguageProficiency(input: $updateLanguageProficiencyInput) {
      viewer {
        languageProficiencies {
          ...languageProficiency
        }
      }
    }
  }
  ${languageProficiency}
`;

export const deleteLanguageProficiency = gql`
  mutation DeleteLanguageProficiency(
    $deleteLanguageProficiencyInput: DeleteLanguageProficiencyInput!
  ) {
    deleteLanguageProficiency(input: $deleteLanguageProficiencyInput) {
      viewer {
        languageProficiencies {
          ...languageProficiency
        }
      }
    }
  }
  ${languageProficiency}
`;
